export const MODULE_CLASS_NAME = 'AuthByKT1Module';